import IDMGlobals from './../IDMGlobals';
import IDMUtils from './../IDMUtils';
//
import Cookies from './../browser/Cookies';
const MemCache = require("node-cache");
//
export default class PersistentSession {
  constructor(datasource) {
    this.datasource = datasource;
    this.storage = new Cookies(datasource.opts && datasource.opts.secureCookieDomain ? datasource.opts.secureCookieDomain : null);
    this.memcache = new MemCache();
    this.localSession = null;
  }

  async clearData() {
    this.localSession = null;
    this.memcache = new MemCache();
    this.storage.cleanKey(IDMGlobals.CookiesKey_IDMToken);
    this.storage.cleanKey(IDMGlobals.CookiesKey_IDMRenewalToken);
    this.storage.cleanKey(IDMGlobals.CookiesKey_IDMSessionData);
    this.storage.cleanKey(IDMGlobals.CookiesKey_IDMResourcesToken);
    this.storage.cleanKey(IDMGlobals.CookiesKey_IDMToken_OLD);
    this.storage.cleanKey(IDMGlobals.CookiesKey_IDMRenewalToken_OLD);
    this.storage.cleanKey(IDMGlobals.CookiesKey_IDMSessionData_OLD);
    this.storage.cleanKey(IDMGlobals.CookiesKey_IDMResourcesToken_OLD);
    this.storage.cleanKey(IDMGlobals.CookiesKey_IDMPublicKey); //cleaning this cookie so we fix same domain IDM issue after logout
    //Do not clean those
    // this.storage.cleanKey(IDMGlobals.CookiesKey_IDMExternalProviders);
    if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Clearing session data!');
  }

  //Getters
  getRenewalToken() {
    if (this.localSession && this.localSession.renewalToken) return this.localSession.renewalToken;
    //load into local cache
    if (!this.localSession) this.localSession = {};
    this.localSession.renewalToken = (this.storage.getValue(IDMGlobals.CookiesKey_IDMRenewalToken) || this.storage.getValue(IDMGlobals.CookiesKey_IDMRenewalToken_OLD));
    //
    return this.localSession.renewalToken;
  }
  getToken() {
    if (this.localSession && this.localSession.token) return this.localSession.token;
    //load into local cache
    if (!this.localSession) this.localSession = {};
    this.localSession.token = (this.storage.getValue(IDMGlobals.CookiesKey_IDMToken) || this.storage.getValue(IDMGlobals.CookiesKey_IDMToken_OLD));
    //
    return this.localSession.token;
  }
  getResourcesToken() {
    if (this.localSession && this.localSession.resourcesToken) return this.localSession.resourcesToken;
    //load into local cache
    if (!this.localSession) this.localSession = {};
    this.localSession.resourcesToken = (this.storage.getValue(IDMGlobals.CookiesKey_IDMResourcesToken) || this.storage.getValue(IDMGlobals.CookiesKey_IDMResourcesToken_OLD));
    //
    return this.localSession.resourcesToken;
  }
  getPublicKey() { //does not cache in memory indefinitely, leave cookie expire decide if we can use or not!
    let publicKey = (this.storage.getValue(IDMGlobals.CookiesKey_IDMPublicKey) || this.storage.getValue(IDMGlobals.CookiesKey_IDMPublicKey_OLD) || this.memcache.get('publicKey'));
    try {
      if (publicKey) publicKey = JSON.parse(publicKey);
    } catch {}
    //
    return (publicKey ? publicKey.pk : null);
  }
  getExternalProviders() { //does not cache in memory indefinitely, leave cookie expire decide if we can use or not!
    let externalProviders = (this.storage.getValue(IDMGlobals.CookiesKey_IDMExternalProviders) || this.memcache.get(IDMGlobals.CookiesKey_IDMExternalProviders));
    try {
      if (externalProviders) externalProviders = JSON.parse(externalProviders);
    } catch { }
    //
    return (externalProviders || null);
  }
  getUserObject() {
    if (this.localSession && this.localSession.additionalMeta && this.localSession.additionalMeta.userObj) return this.localSession.additionalMeta.userObj;
    //load into local cache
    if (!this.localSession) this.localSession = {};
    this.localSession.additionalMeta = this.getUserData();
    //
    return (this.localSession.additionalMeta && this.localSession.additionalMeta.userObj ? this.localSession.additionalMeta.userObj : null);
  }
  
  getUserData() {
    let val = (this.storage.getValue(IDMGlobals.CookiesKey_IDMSessionData) || this.storage.getValue(IDMGlobals.CookiesKey_IDMSessionData_OLD));
    try {
      if (val) val = JSON.parse(val);
    } catch (e) {}
    return val;
  }
  //Setter
  saveExternalProviders(externalProviders) {
    const expireDate = IDMUtils.timestampAfterHours(24);
    this.memcache.set(IDMGlobals.CookiesKey_IDMExternalProviders, JSON.stringify(externalProviders), (expireDate - Date.now()) / 1000);
    this.storage.setValue(IDMGlobals.CookiesKey_IDMExternalProviders, JSON.stringify(externalProviders), { expires: new Date(expireDate) });
  }
  savePublicKey(pk) {
    const expireDate = IDMUtils.timestampAfterHours(IDMGlobals.CookiesPublicKeyExpiration);
    this.memcache.set("publicKey", JSON.stringify({ pk }), (expireDate - Date.now()) / 1000);
    this.storage.setValue(IDMGlobals.CookiesKey_IDMPublicKey, JSON.stringify({ pk }), { expires: new Date(expireDate) });
  }
  saveSession(session) {
    this.localSession = session;
    if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.log("setting session to local storage", session)
    if (session.renewalToken) {
      this.storage.setLongLiveValue(IDMGlobals.CookiesKey_IDMRenewalToken, session.renewalToken);
    }
    if (session.resourcesToken) {
      this.storage.setLongLiveValue(IDMGlobals.CookiesKey_IDMResourcesToken, session.resourcesToken);
    }
    if (session.token) {
      this.storage.setLongLiveValue(IDMGlobals.CookiesKey_IDMToken, session.token);
    }
    if (session.additionalMeta) {
      if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('setting user data: ', session.additionalMeta);
      this.storage.setLongLiveValue(IDMGlobals.CookiesKey_IDMSessionData, JSON.stringify(session.additionalMeta));
    }
  }
  deletePartitionByID(id) {
    if (!this.localSession || !this.localSession.additionalMeta) return;
    const data = this.localSession.additionalMeta;
    if (!(data && data.parts)) return;
    data.parts[id] = null;
    this.storage.setLongLiveValue(IDMGlobals.CookiesKey_IDMSessionData, JSON.stringify(data));
  }
  appendPartitionDataByID(partData, partID) {
    //Allow empty insertion
    if (!this.localSession) {
      this.localSession = { additionalMeta: { parts: {} } };
    } else if (!this.localSession.additionalMeta) {
      this.localSession.additionalMeta = { parts: {} };
    } else if (!this.localSession.additionalMeta.parts) {
      this.localSession.additionalMeta.parts = {};
    }
    //Actually set partition and save to storage
    const data = this.localSession.additionalMeta;
    if (partData && data && data.parts) {
      data.parts[partID] = partData;
      this.storage.setLongLiveValue(IDMGlobals.CookiesKey_IDMSessionData, JSON.stringify(data));
    }
  }
}
